import React, { useState } from "react";
import { Alert } from "reactstrap";
import StepCompleteActionButton from "./StepCompleteActionButton";
import { updateUserOnboardingConfig } from "helpers/fakebackend_helper";

const FilingStatusStep = ({ step, token, email, onNext }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSelect = async (status) => {
        setError("");
        setLoading(true);

        try {
            const res = await updateUserOnboardingConfig(token, {
                email,
                filing_status: status
            });

            setLoading(false);

            if (res.code !== 1) {
                setError(res.message || "Failed to save filing status.");
                return;
            }

            onNext();

        } catch (err) {
            setLoading(false);
            setError(err.message || "Unexpected error.");
        }
    };

    return (
        <>
            {error && <Alert color="danger">{error}</Alert>}

            <h1 className="text-dark mb-4 fw-semibold">{step.step_title}</h1>
            <h6 className="text-dark mb-4" style={{ whiteSpace: "pre-line" }}>{step.step_description}</h6>

            <StepCompleteActionButton
                label="Single or Married Filing Separately"
                onClick={() => handleSelect("Single or Married Filing Separately")}
                disabled={loading}
            />

            <div className="mt-3" />

            <StepCompleteActionButton
                label="Married Filing Jointly or Qualifying Surviving Spouse"
                onClick={() => handleSelect("Married Filing Jointly or Qualifying Surviving Spouse")}
                disabled={loading}
            />

            <div className="mt-3" />

            <StepCompleteActionButton
                label="Head of Household"
                onClick={() => handleSelect("Head of Household")}
                disabled={loading}
            />
        </>
    );
};

export default FilingStatusStep;